<app-loader></app-loader>
<app-application-dialog
	*ngIf="isAppDisplayed"
	[application]="appDisplayed"
	(onCloseRequested)="closeFrame()"
></app-application-dialog>
<mat-sidenav-container>
	<!-- FIN MODULARIZACION -->
	<mat-sidenav #sidenav mode="side" position="end" [(opened)]="opened" opened>
		<div class="profile-panel">
			<div class="panel-header">
				<h3>{{ "header.toolbar.userPanel.profileTitle" | translate }}</h3>
				<button
					class="panel-close-btn"
					type="button"
					(click)="toggle()"
					[attr.aria-label]="'header.toolbar.userPanel.closePanelAria' | translate"
				>
					<mat-icon>close</mat-icon>
				</button>
			</div>

			<div class="panel-body">
				<section class="profile-hero">
					<div class="avatar-shell">
						<img [src]="photo" class="avatar avatar-image" [attr.alt]="'header.toolbar.userPanel.userPhotoAlt' | translate" />
					</div>
					<div class="hero-content">
						<h2>{{ userProfile?.name || userProfile?.username }}</h2>
						<p>{{ userProfile?.username }}</p>
					</div>
				</section>

				<section class="profile-section">
					<h3>{{ "header.toolbar.userPanel.directory" | translate }}</h3>
					<div class="kv-grid">
						<div class="kv-row">
							<span class="kv-label">{{ "header.toolbar.userPanel.office" | translate }}</span>
							<span class="kv-value">{{ officeDisplay }}</span>
						</div>
					</div>
				</section>

				<section class="profile-section">
					<h3>{{ "header.toolbar.userPanel.session" | translate }}</h3>
					<div class="kv-grid">
						<div class="kv-row kv-row--interactive" (click)="openLanguageSelector()">
							<span class="kv-label">{{ "header.toolbar.userPanel.languageLabel" | translate }}</span>
							<span class="kv-value kv-value--editable">
								<img class="kv-flag" [src]="'assets/flags/' + dictionary[langSelected] + '.svg'" alt="" />
								{{ languageName }}
								<mat-icon class="kv-edit-icon">edit</mat-icon>
							</span>
						</div>
						<div class="kv-row">
							<span class="kv-label">{{ "header.toolbar.userPanel.utcOffsetLabel" | translate }}</span>
							<span class="kv-value">{{ utcOffsetDisplay }}</span>
						</div>
					</div>
				</section>

				<section class="profile-section">
					<h3>{{ "header.toolbar.userPanel.versionTitle" | translate }}</h3>
					<div class="kv-grid">
						<div class="kv-row">
							<span class="kv-label kv-label-with-icon">
								<mat-icon class="kv-inline-icon">label</mat-icon>
								{{ "header.toolbar.userPanel.frontVersionLabel" | translate }}
							</span>
							<span class="kv-value">{{ frontVersionDisplay }}</span>
						</div>
						<div class="kv-row">
							<span class="kv-label kv-label-with-icon">
								<mat-icon class="kv-inline-icon">label_outline</mat-icon>
								{{ "header.toolbar.userPanel.backVersionLabel" | translate }}
							</span>
							<span class="kv-value">{{ backVersionDisplay }}</span>
						</div>
					</div>
				</section>

				<section class="profile-section">
					<h3>{{ "header.toolbar.userPanel.myProfileTitle" | translate }}</h3>
					<p class="empty-row" style="margin-bottom: 0.6rem">
						{{ "header.toolbar.userPanel.myProfileHint" | translate }}
					</p>
					<button type="button" class="btn btn-ghost" style="width: 100%" (click)="goToMiPerfil()">
						<span class="ic"><mat-icon>badge</mat-icon></span>
						{{ "header.toolbar.userPanel.myProfileCta" | translate }}
					</button>
					<button type="button" class="btn btn-ghost" style="width: 100%; margin-top: 8px" (click)="goToMisResponsabilidades()">
						<span class="ic"><mat-icon>fact_check</mat-icon></span>
						{{ "header.toolbar.userPanel.myResponsibilitiesCta" | translate }}
					</button>
					<button type="button" class="btn btn-ghost" style="width: 100%; margin-top: 8px" (click)="goToConceptos()">
						<span class="ic"><mat-icon>auto_stories</mat-icon></span>
						{{ "header.toolbar.userPanel.conceptsCta" | translate }}
					</button>
					<!-- Gestión energética: solo gestores de energía (App.Energia.View) y ADMIN -->
					<button type="button" class="btn btn-ghost" style="width: 100%; margin-top: 8px" *ngIf="canVerEnergia" (click)="goToEnergia()">
						<span class="ic"><mat-icon>bolt</mat-icon></span>
						{{ "header.toolbar.userPanel.energyCta" | translate }}
					</button>
				</section>
			</div>

			<div class="profile-actions">
				<button type="button" class="btn btn-primary" (click)="logout()">
					<span class="ic"><mat-icon>logout</mat-icon></span>
					{{ "header.toolbar.logout" | translate }}
				</button>
			</div>
		</div>
	</mat-sidenav>
	<mat-sidenav-content>
		<!-- Fondo de la landing: imagen a top:0, bajo el header (solo en Inicio) -->
		<div class="landing-bg" *ngIf="isLanding" aria-hidden="true"></div>
		<app-header (toggleProfile)="toggle()"></app-header>
		<app-breadcrumbs></app-breadcrumbs>
		<router-outlet></router-outlet>
	</mat-sidenav-content>
</mat-sidenav-container>
